import { getFriendlyErrorMessage, NETWORK_ERROR_MESSAGE } from "../../utils/apiErrors";

const API_BASE_URL = process.env.REACT_APP_BE_API_URL;

/**
 * Envía una postulación para un puesto
 * @param formData - FormData con name, email, phone, message, cv, recaptchaToken
 * @returns Respuesta del servidor
 */
export const submitJobApplication = async (formData: FormData): Promise<any> => {
  try {
    const response = await fetch(`${API_BASE_URL}/applications/submit`, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      let friendlyMessage = "";

      // Intentamos obtener mensaje específico del backend primero
      try {
        const errorData = await response.json();
        friendlyMessage = errorData.message || errorData.error;
      } catch (e) {
        // No hay JSON o mensaje en la respuesta
      }

      if (!friendlyMessage) {
        friendlyMessage = getFriendlyErrorMessage(response.status, 'careers');
      }

      const error = new Error(friendlyMessage);
      (error as any).friendlyMessage = friendlyMessage;
      (error as any).status = response.status;
      throw error;
    }

    return await response.json();
  } catch (error: any) {
    if (error.friendlyMessage) throw error;
    
    const networkError = new Error("Error de conexión");
    (networkError as any).friendlyMessage = NETWORK_ERROR_MESSAGE;
    throw networkError;
  }
};
